{
  "seed": 1337,
  "dust": { "count": 3000, "box": 300 },
  "camera": { "fovDeg": 70, "near": 0.5 },
  "spawn": { "position": [0, 0, 0], "respawnDelay": 3 }
}
